<template>
    <form class="form-signin">
      <div class="mb-4 agis-title-container" >
        <div class='agis-title'><img  class="aa-logo" src='@/assets/aa_logo_white.png'/>AGIS</div>
      </div>
      <!--<h1 class="h3 mb-3 font-weight-normal">Please sign in</h1>
      <label for="inputEmail" class="sr-only">Email address</label>
      <input type="email" id="inputEmail" class="form-control" placeholder="Email address" required autofocus>
      <label for="inputPassword" class="sr-only">Password</label>
      <input type="password" id="inputPassword" class="form-control" placeholder="Password" required>
      <div class="checkbox mb-3">
        <label>
          <input type="checkbox" value="remember-me"> Remember me
        </label>
      </div>-->
      <b-button :block='true' :to="{ path: 'home' }" variant="primary">Sign in</b-button>
      <!--<button v-on:click='login' v-on:submit.prevent='onSubmit' class="btn btn-lg btn-primary btn-block" type="submit">Sign in</button>-->
      <p class="mt-5 mb-3 text-muted">&copy; Airport Authority Hong Kong. All Rights Reserved.</p>
    </form>
</template>

<script>
export default {
  name:'login',
  created:function(){
    
      //check if esri_auth is in cookie. It should exist if user already login at Portal.
      //ref: https://firstdoit.com/quick-tip-one-liner-cookie-read-c695ecb4fe59
      var esriAuthInCookie = ('; ' + document.cookie)
      .split('; ' + "esri_auth" + '=')
      .pop()
      .split(';')
      .shift()

      // if esri_auth is in cookie, attempt login by redirecting user to home page
      if(esriAuthInCookie){
        this.$router.replace({ path: 'home' });
      }
  }
}
</script>


<style scoped>
html,
body {
  height: 100%;
}

body {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #f5f5f5;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.agis-title-container{
  background: gray;
  width:auto;
  height:10rem;
  display: flex;
  justify-content: center;
  align-items:center;
  border-radius: 10px;
}

.agis-title{
  font-size: 3rem;
  color:white;
  font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/account/Login.vue